import {
    LitElement, html
} from 'lit-element';
import {getScript} from '../../../../utilities/utils.js';
import {raiPlayerEvents} from 'RaiPlay/assets-src/js/webcomponents/src/rai-player/player-events';

import { Subject } from 'rxjs';
import { first, takeUntil, filter } from 'rxjs/operators';
import { getDomain } from '../../../../libraries/packages/rai-adv/src/functions';

const unsubscribe$ = new Subject();
const trackEnqueue = window.Rai._trackEnqueue;

const MEMO_APP_ID =             'P8BE1A60C-9250-4B16-8FBD-3BB359E44CB3';

const RAIIT_APP_ID_DEFAULT =    'PA6C62438-C296-4984-8B10-B30636C39D4E';

const RAISCUOLA_APP_ID =        'P496900DB-A5B0-4D70-99C4-0C8A7EC76F34';
const RAICULTURA_APP_ID =       'P26486DDA-2174-4C0A-9DB2-932D4B55BDE8';

const RAIPLAYSOUND_HP =         'P21B94238-2422-4499-BCFE-5278F756C743';
const RAIPLAYSOUND =            'P9585DD50-2F01-4F67-B5D7-1B91483865EA';
const RAIPLAYSOUND_DIRETTE =    'P75D2F3EE-B308-4505-BED5-A2542635E7D6';
const RAIPLAYSOUND_ON_DEMAND =  'PED6B31DD-946B-4428-8DE3-7208DB939CAF';
const RAIPLAYSOUND_AUDIOLIBRI = 'P6B615D9A-188E-4F8C-A68C-8AFDB1068880';

const RAINEWS_APP_ID_DEFAULT =  'P1BB3E6ED-1B4A-4FC0-AB2B-134D4A9989DE';
const RAINEWS_HP_ID =           'PEDD54F7A-4198-4630-91F0-AB6D24EADFCE';
const RAINEWS_APPR_ID =         'PC0E30EC8-D666-4D7A-A048-966116AEC89D';
const RAINEWS_DIRETTE_ID =      'PFA00B8E1-9A3E-4B77-9B61-E6EC01C04FBE';
const RAINEWS_NOTIZIARI_ID =    'PFA00B8E1-9A3E-4B77-9B61-E6EC01C04FBE';
const RAINEWS_TGR_ID =          'P3FE314A3-85D5-4F6A-BED8-C2305E8FC0B0';
const RAINEWS_ARCHIVIO_ID =     'P628A27F0-B2A3-4304-A340-73D522AEDFAD';
const RAINEWS_SPORT_ID =        'P1644FE75-760E-4005-9022-225556964485';

const RAINEWS_APP_ID_MEDIA =    'P29DA9F4E-28A5-40D2-8A85-480C18518450';

const RAISPORT_APP_ID =         'P1644FE75-760E-4005-9022-225556964485';
const RAISPORT_APP_ID_MEDIA =   'P66ABF4FE-3398-461B-AB04-29E3597E628A';
const RAISPORT_HP_ID =          'PBB19E3EF-A821-4700-A5DE-E109F942107D';
const RAISPORT_VOD_ID =         'PDAF54851-CBD9-4057-95DB-3EA04FBC9955';
const RAISPORT_CALCIO_ID =      'P63733A88-BFF4-4601-8EA8-84272EB4A89F';
const RAISPORT_ALTRI_SPORT_ID = 'PDEB67730-FD77-4E17-8650-3CFBFB44C447';

const RAIPLAY_APP_ID_DEFAULT =  'PC991BBA3-EAB0-4C17-8448-538B71E10785';
const RAIPLAY_APP_ID_MEDIA =    'P05460EF0-1432-44AB-9989-0792142743FB';
const RAIPLAY_VOD_ID =          'PCEDC92C0-AECF-4A44-8BF6-BE8C06BCB8A8';
const RAIPLAY_HP_ID =           'PCC76C7AE-27C0-4992-80EC-485231C1A71D';
const RAIPLAY_PRG_ID =          'P38834CE7-345B-4B99-8229-B9D62965F2BD';
const RAIPLAY_DIRETTE_ID =      'P2C6F76BF-6988-4A03-BF36-C5E2409A3475';
const RAIPLAY_YOYO_ID =         'PE4AF27A2-2F19-4608-9611-CAF74AFE73E6';
const RAIPLAY_ACCOUNT_ID =      'PF589024B-256A-49B1-AF84-FB15F2FC355B';
const RAIPLAY_SPORT_ID =        'PCEDC92C0-AECF-4A44-8BF6-BE8C06BCB8A8';

const CORPORATE_APP_ID =        'PEA515014-1E4C-47CE-8135-AF53DD26E171';


export default class _Nielsen extends LitElement {
    static get properties() {
        return {
            pageInfo: {type: Object},
            mediaInfo: {type: Object},
            mode: {type: String},
            pageInfoBaseData: {type: Object}
        };
    }
    constructor(){
        super();
    }
    updated(chg){
        !!this.mediaInfo && !this.handledEvents && this.initMediaTrack();
    }
    render(){
        return html``;
    }
    firstUpdated(){
        trackEnqueue.pageQueue
        .pipe(
            filter(Boolean),
            first(),
            takeUntil(unsubscribe$)
        )
        .subscribe(pageInfo => {
            this.pageInfo = pageInfo;

            // Static Queue Snippet
            !function(t,n){t[n] = t[n] || {
                nlsQ:function(e,o,c,r,s,i)
                {
                    return s=t.document,
                    r=s.createElement("script"),
                    r.async=1,
                    r.src=("http:"===t.location.protocol?"http:":"https:")+"//cdn-gl.imrworldwide.com/conf/"+e+".js#name="+o+"&ns="+n,i=s.getElementsByTagName("script")[0],i.parentNode.insertBefore(r,i),
                    t[o]=t[o]||{g:c,ggPM:function(n,e,c,r,s){(t[o].q=t[o].q||[]).push([n,e,c,r,s])}},t[o]}
                }
            }
            (window,"NOLBUNDLE");

            // SDK Initialization
            if(!this.staticLoaded){
                let selfHref = window.self.location.href;
                let topHref = document.referrer;
                if(!(window.self !== window.top && topHref.split(".it/")[0] == selfHref.split(".it/")[0])){ /**Escluso init e tracciamento pagina su iframe same-site */
                    this.nSdkPageInstance = NOLBUNDLE.nlsQ(this.staticInfo.appID, "raiStatic_"+ Date.now(), this.DEBUG ? {nol_sdkDebug: "debug"} : {});
                    
                        if(pageInfo.mode != 'action' && this.mode == 'extendInfoByComponent'){
                            Object.assign(pageInfo, this.pageInfoBaseData)
                        }
                        this.pageInfo = pageInfo;
                        this.trackPage();
                    
                    this.staticLoaded = true;
                }
            }
        });
    }
    connectedCallback(){
        super.connectedCallback();
        this.initMediaTrack = this.initMediaTrack.bind(this);
        this.trackPage = this.trackPage.bind(this);
        this.DEBUG = document.location.search == '?trackDebug';
        this.staticInfo =
         (function(){
            let info;
            let mapping = {
                "raiplaysound":{
                    '^\\/$': { appID: RAIPLAYSOUND_HP, section: 'RaiPlaySoundHomePage_BRW' },
                    '^\\/dirette': { appID: RAIPLAYSOUND_DIRETTE, section: 'RaiPlaySoundDirette_BRW' },
                    '^\\/playlist': { appID: RAIPLAYSOUND_ON_DEMAND, section: 'RaiPlaySoundOnDemand_BRW' },
                    '^\\/audio/': { appID: RAIPLAYSOUND_ON_DEMAND, section: 'RaiPlaySoundOnDemand_BRW' },
                    '^\\/generi': { appID: RAIPLAYSOUND_ON_DEMAND, section: 'RaiPlaySoundOnDemand_BRW' },
                    '^\\/i-miei-podcast': { appID: RAIPLAYSOUND_ON_DEMAND, section: 'RaiPlaySoundOnDemand_BRW' },
                    '^\\/ricerca': { appID: RAIPLAYSOUND_ON_DEMAND, section: 'RaiPlaySoundOnDemand_BRW' },
                    '^\\/programmi': { appID: RAIPLAYSOUND_ON_DEMAND, section: 'RaiPlaySoundOnDemand_BRW' },
                    '^\\/programmi\\/adaltavoce': { appID: RAIPLAYSOUND_AUDIOLIBRI, section: 'RaiPlaySoundAudiolibri_BRW' },
                },
                "raiplay":{
                    '^\\/$': {appID: RAIPLAY_HP_ID, section: 'RaiplayHomepage_BRW'},
                    '^\\/programmi': {appID: RAIPLAY_PRG_ID, section: 'RaiplayProgrammi_BRW'},
                    '^\\/euro2020': {appID: RAIPLAY_PRG_ID, section: 'RaiplayProgrammi_BRW'},
                    '^\\/dirette': {appID: RAIPLAY_DIRETTE_ID, section: 'RaiplayDirette_BRW'},
                    '^\\/dirette\\/raiyoyo': {appID: RAIPLAY_YOYO_ID, section: 'RaiplayYoyo_BRW'},
                    '^\\/bambini': {appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/documentari': {appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/fiction': {appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/film': {appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/genere': {appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/performing-arts': {appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/programmi\\/quellicheilcalcio': {appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/serietv': {appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/techerai': {appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/video': {appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/guidatv': { appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW' },
                    '^\\/teen': { appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW' },
                    '^\\/sport': { appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW' },
                    '^\\/learning': { appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW' },
                    '^\\/musica-e-teatro': { appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW' },
                    '^\\/ricerca.html': { appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW' },
                    '^\\/account': {appID:RAIPLAY_ACCOUNT_ID ,section:'RaiPlayPagineAccount_BRW'},
                    '^\\/scrivici': {appID:RAIPLAY_ACCOUNT_ID ,section:'RaiPlayPagineAccount_BRW'},
                    '^\\/associa': {appID:RAIPLAY_ACCOUNT_ID ,section:'RaiPlayPagineAccount_BRW'},
                    '^\\/la-mia-lista': {appID:RAIPLAY_ACCOUNT_ID ,section:'RaiPlayPagineAccount_BRW'},
                    '^\\/lucca-comics-and-games': { appID: RAIPLAY_SPORT_ID, section: 'RaiplayVOD_BRW' },
                    '^\\/sport\\/': {appID: RAIPLAY_SPORT_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/serieitaliane': {appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/serieinternazionali': {appID: RAIPLAY_VOD_ID, section: 'RaiplayVOD_BRW'},
                    '^\\/iframe\\/video\\/2018\\/04\\/Promo-Raiplay-Yoyo-da3036bd-6e65-46a9-a5b2-e728747ad484.html' : {appID: RAIPLAY_YOYO_ID, section: 'RaiplayYoyo_BRW'}
                },
                "rai":{
                    '^\\/$': {appID: RAIIT_APP_ID_DEFAULT, section: 'Rai.itHomePage_BRW', mediaAppID: RAIIT_APP_ID_DEFAULT},
                    '^\\/presentazionepalinsesti': {appID: RAIIT_APP_ID_DEFAULT, section: 'Rai.itHomePage_BRW', mediaAppID: RAIIT_APP_ID_DEFAULT},
                    '^\\/smartcard': { appID: CORPORATE_APP_ID, section: 'Smartcard_BRW', mediaAppID: CORPORATE_APP_ID },
                    '^\\/bilanciodisostenibilita': { appID: CORPORATE_APP_ID, section: 'RaiCorporate_BRW', mediaAppID: CORPORATE_APP_ID},
                    '^\\/milluminodimeno': { appID: CORPORATE_APP_ID, section: 'RaiCorporate_BRW', mediaAppID: CORPORATE_APP_ID },
                    '^\\/centroassistenza': { appID: CORPORATE_APP_ID, section: 'RaiCorporate_BRW', mediaAppID: CORPORATE_APP_ID }
                },
                "rainews":{
                    '^\\/$': {appID: RAINEWS_HP_ID, section: 'RaiNewsHomePage_BRW'},
                    '^\\/rubriche\\/': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},

                    '^\\/video\\/': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/maratona': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/audio\\/': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/articoli\\/': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/dossier\\/': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/ambiente': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/artiespettacolo': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/cronaca': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/economiaefinanza': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/esteri': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/politica': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/salute': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/scienzaetecnologia': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/societa': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/sport': {appID: RAINEWS_SPORT_ID, section: 'RaiNewsAttualitaSportiva_BRW'},
                    '^\\/stilidivitaetempolibero': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/viaggieturismo': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/storie': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/ricerca': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/tag?': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/archivio': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/archivio\\/sport': {appID: RAINEWS_SPORT_ID, section: 'RaiNewsAttualitaSportiva_BRW'},

                    '^\\/dirette\\/': {appID: RAINEWS_DIRETTE_ID, section: 'RaiNewsAttualitaNazionale_BRW'},
                    '^\\/notiziari\\/': {appID: RAINEWS_NOTIZIARI_ID, section: 'RaiNewsAttualitaNazionale_BRW'},
                    '^\\/tgr': {appID: RAINEWS_TGR_ID, section: 'RaiNewsAttualitaRegionale_BRW'},
                    '^\\/archivio-rainews\\/': {appID: RAINEWS_ARCHIVIO_ID, section: 'RaiNewsArchivio_BRW'},

                    /**SottoSiti Esterni */
                    '^\\//dl\\/rainews\\/speciali-portale\\/manipulite2022\\/': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\//dl\\/rainews\\/speciali-portale\\/manipulite\\/': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/speciali\\/manipulite2022': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},

                    '^\\/dl\\/rainews\\/speciali-portale\\/giornatadellamemoria2022\\/': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},
                    '^\\/speciali\\/giornatadellamemoria2022': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'},

                    '^\\/ran24\\/speciali\\/2020\\/covid19\\/': {appID: RAINEWS_APPR_ID, section: 'RaiNewsApprofondimenti_BRW'}
                },
                "raisport":{
                    '^\\/$': {appID: RAISPORT_HP_ID, section:'RaiSportHomepage_BRW'},
                    '^\\/dl\\/raiSport\\/speciali(\\/live)?\\/calcio': {appID: RAISPORT_ALTRI_SPORT_ID, section: 'RaiSportArticoli_BRW'},
                    '^\\/articoli\\/': {appID: RAISPORT_ALTRI_SPORT_ID, section: 'RaiSportArticoli_BRW'},
                    '^\\/dirette.html': {appID: RAISPORT_VOD_ID, section: 'RaiSportVideo_BRW'},
                    '^\\/video\\/': {appID: RAISPORT_VOD_ID, section: 'RaiSportVideo_BRW'},
                    '^\\/foto\\/': {appID: RAISPORT_ALTRI_SPORT_ID, section: 'RaiALTRISPORT_BRW'},
                    '^\\/archivio.html': {appID: RAISPORT_ALTRI_SPORT_ID, section: 'RaiSportArticoli_BRW'},
                    '^\\/archivio.html\\?tematica=calcio': {appID: RAISPORT_ALTRI_SPORT_ID, section: 'RaiCALCIO_BRW'},
                    '^\\/speciali\\/': {appID: RAISPORT_ALTRI_SPORT_ID, section: 'RaiSportArticoli_BRW'},
                    '^\\/dl/rai24/assets/template/iframe.html': {appID: RAISPORT_ALTRI_SPORT_ID, section: 'RaiALTRISPORT_BRW'},
                    '^\\/approfondimenti\\/calcio-euro-2020': {appID: RAISPORT_ALTRI_SPORT_ID, section: 'RaiSportArticoli_BRW'}
                },
                "raiplayyoyo": {
                    '^\\/$': {appID: RAIPLAY_YOYO_ID, section:'RaiplayYoyo_BRW'},
                }
            }

            let _domain = getDomain();
            switch(_domain){
                case 'raiplaysound':
                    info = { appID: RAIPLAYSOUND, section: 'RaiPlaySound_BRW' };
                    let _pageType = document.querySelector('meta[name="pageType"]') ?? undefined;
                    if(!!_pageType && _pageType.content === 'canale'){
                        info = { appID: RAIPLAYSOUND_DIRETTE, section: 'RaiPlaySoundDirette_BRW' };
                    }else if(document.location.pathname.toLocaleLowerCase().indexOf("audiolibri")!==-1){
                        info = { appID: RAIPLAYSOUND_AUDIOLIBRI, section: 'RaiPlaySoundAudiolibri_BRW' };
                    }else{
                        Object.entries(mapping.raiplaysound).forEach(regexBlock => {
                            if (new RegExp(regexBlock[0]).test(document.location.pathname)) {
                                info.appID = regexBlock[1].appID;
                                info.section = regexBlock[1].section;
                            }
                        });
                    }
                break;
                case 'raiplay':
                    info = {appID: RAIPLAY_APP_ID_DEFAULT, section: 'Raiplay_BRW', mediaAppID: RAIPLAY_APP_ID_MEDIA};
                    Object.entries(mapping.raiplay).forEach(regexBlock => {
                        if(new RegExp(regexBlock[0]).test(document.location.pathname)){
                            info.appID = regexBlock[1].appID;
                            info.section = regexBlock[1].section;
                        }
                    });
                break;
                case 'raiscuola':
                    info = {appID: RAISCUOLA_APP_ID, section: 'Raiscuola_BRW', mediaAppID:RAISCUOLA_APP_ID};
                break;
                case 'raicultura':
                    info = {appID: RAICULTURA_APP_ID, section: 'RaiCultura_BRW', mediaAppID:RAICULTURA_APP_ID};
                break;
                case 'memo':
                    info = {appID: MEMO_APP_ID, section: 'Memo_BRW', mediaAppID:MEMO_APP_ID};
                break;
                case "rainews":
                    info = {appID: RAINEWS_APP_ID_DEFAULT, section: 'RaiNews_BRW', mediaAppID: RAINEWS_APP_ID_MEDIA};
                    Object.entries(mapping.rainews).forEach(regexBlock => {
                        if(new RegExp(regexBlock[0]).test(document.location.pathname)){
                            info.appID = regexBlock[1].appID;
                            info.section = regexBlock[1].section;
                        }
                    });
                break;
                case "rai":
                    info = {appID: RAIIT_APP_ID_DEFAULT, section: 'Rai.itHomePage_BRW"', mediaAppID: RAIIT_APP_ID_DEFAULT};
                    Object.entries(mapping.rai).forEach(regexBlock => {
                        if(new RegExp(regexBlock[0]).test(document.location.pathname)){
                            info.appID = regexBlock[1].appID;
                            info.section = regexBlock[1].section;
                            info.mediaAppID = regexBlock[1].mediaAppID ? regexBlock[1].mediaAppID : info.mediaAppID;
                        }
                    });

                break;
                case 'raisport':
                    info = {appID: RAISPORT_APP_ID, section: 'RaiSport_BRW', mediaAppID: RAISPORT_APP_ID_MEDIA};
                    Object.entries(mapping.raisport).forEach(regexBlock => {
                        if(new RegExp(regexBlock[0]).test(document.location.pathname + document.location.search)){
                            info.appID = regexBlock[1].appID;
                            info.section = regexBlock[1].section;
                        }
                    });
                break;
                case 'servizitelevideo':
                case 'televideo':
                case 'origintelevideo':
                    info = {appID: RAINEWS_APP_ID_DEFAULT, section: 'RaiNews_BRW', mediaAppID: RAINEWS_APP_ID_MEDIA};
                    break;
                case 'raiplayyoyo':
                    info = { appID: RAIPLAY_YOYO_ID, section: 'RaiplayYoyo_BRW', mediaAppID: RAIPLAY_YOYO_ID };
                    break;
            }
            return info;
        })();
    }
    disconnectedCallback(){
        super.disconnectedCallback();
        unsubscribe$.next();
        unsubscribe$.complete();
    }

    initMediaTrack(){
        this.hbStarted = false;
        this.stopHeartbeat = (useLastContentTime) => {
            let t = useLastContentTime === true ? this.lastContentTime : this.time;
            window.clearInterval(this.hbIntervall);

            this.hbStarted=false;
            if(this.lastPlayheadPosition > t){
                //controllo per fixare l'arrotondamento per difetto del currTime
                t = this.lastPlayheadPosition;
                if(useLastContentTime === true){this.lastContentTime = this.lastPlayheadPosition;}
                else{this.time = this.lastPlayheadPosition;}
            }
            let i= this.lastPlayheadPosition;
            while(i <= t-1 && i>t-3){ //controllo per evitare gli skip del playheadposition
                i++;
                this.nSdkInstance.ggPM('setPlayheadPosition', i);  
            }
            this.DEBUG && console.log('rai test: stopplayheadposition ');
        };
        this.startHeartbeat = (from) => {
            if(this.hbStarted){return;}
            if(typeof(from)!=='number'){from = 0;}
            this.hbStarted=true;
            this.DEBUG && console.log('rai test: startplayheadposition ');
            this.hbIntervall=window.setInterval(() => {
            if(!this.mediaInfo.is_live && from >= this.contentLength){
                this.sendStreamEnd(this.contentLength);
                return false;
            }
            this.lastPlayheadPosition=from;
            this.nSdkInstance.ggPM('setPlayheadPosition', from);
            from++;
            },1000);
        };
        this.sendStreamEnd = () =>{
            if(!this.streamEndFired){
                this.streamEndFired = true;
                this.stopHeartbeat();
                this.nSdkInstance.ggPM('end', this.time);
              }
        };
        this.closePlayer = () => {
            if(this.playerClosed || !this.playerCreated){return}

            this.playerClosed=true;
            if(this.hbStarted){this.stopHeartbeat(!this.isInAdv);}
            this.isInAdv && this.nSdkInstance.ggPM('stop', this.time); //solo se content
            console.log("test: stop sended");
            this.nSdkInstance.ggPM('end', this.lastContentTime);
            console.log("test: end sended");
        }

        /*bindPlayerEvents*/
        let events = raiPlayerEvents.media;
        let handledEvents = [
            events.LOADMETADATA,
            events.PLAYBACK_STARTED,
            events.REPLAY,
            events.READY,
            events.FIRSTPLAY,
            events.ADS.LOADED,
            events.ADS.STARTED,
            events.PLAYING,
            events.ADS.RESUMED,
            events.PAUSE,
            events.BUFFERING_STARTED,
            events.BUFFERING_END,
            events.SEEK_START,
            events.SEEK_END,
            events.READY_FOR_POSTROLL,
            events.ENDED,
            events.DISPOSE,
            events.ADS.COMPLETE,
            events.ADS.SKIPPED,
            /* events.ADS.PAUSED, */    /* lavorazione temp per rimuovere doppio stop su flussi pubblicitari "corrotti" */
            events.ADS.ADBUFFERING,
            events.ADS.ADBUFFERINGEND,
            /*events.DOWNLOAD_DATA_START,
            events.DOWNLOAD_DATA_END,*/
            events.NETWORK_ERROR,
            events.ADS.ERROR
        ];

        this.handledEvents = events;

        trackEnqueue.mediaQueue                                                                 /* media track */
            .pipe(
                filter(plEvent => handledEvents.includes(plEvent.type)),
                takeUntil(unsubscribe$)
            )
            .subscribe(plEvent => {
                try{this.trackMedia(plEvent.detail.eventData)}
                catch(e){console.error(e);}
            });
    }
    trackPage(){
        let url = new URL(document.location.href);
        let hostname = document.location.hostname;
        let assetid = (function(_this){
            switch(true){
                case hostname.includes('raiplay') && document.location.pathname == '/guidatv':
                    return 'guidatv_' + url.searchParams.get("channel") + '_' + url.searchParams.get("date");
                case hostname.includes('raisport') && document.location.pathname == '/archivio.html':
                    return 'archivio_' + url.searchParams.get("tematica");
                default:
                    return _this.pageInfo.id || document.location.pathname.replace(/[^\w\s\/-]/gi, '').replace(/\//gi, '__')
            }
        })(this);

        // Content Metadata 
        let nielsenMetadata = {
            type: 'static',
            assetid: assetid,
            section: this.staticInfo.section
        };

        if (hostname.includes('rainews') && document.location.pathname.includes('/webview')) return;
        if (navigator?.userAgent?.includes('Rai24')) return;

        this.nSdkPageInstance.ggPM("staticstart", nielsenMetadata);
    }
    trackMedia(event){
        let events = this.handledEvents;
        let mediaInfo = this.mediaInfo;
        let track_info = this.mediaInfo.track_info;

        this.time = mediaInfo.is_live && event.mediaType=='content' ? parseInt(Date.now()/1000) : parseInt(event.currentTime);

        let initNlSdk = (force) => {
            if (!!this.nSdkInstance && !force) return;
            if (!this.playerClosed) this.nSdkInstance = NOLBUNDLE.nlsQ(this.staticInfo.mediaAppID, "raiPlayer_"+ Date.now(), this.DEBUG ? {nol_sdkDebug: "debug"} : {});
            this.contentMetadataObject = {
                type: 'content',
                assetid: track_info.id.slice(12),
                program: mediaInfo.is_live
                            ? track_info.title.substring(0, 100)
                            : (!!track_info.program_title ? track_info.program_title.substring(0, 100) : track_info.id),
                title: mediaInfo.is_live ? 'la diretta di ' + track_info.channel + ' in streaming live' : track_info.title.substring(0, 100),
                length: mediaInfo.is_live ? '86400' : event.mediaDuration.toString(),
                airdate: mediaInfo.is_live ? '19700101 00:00:00' : mediaInfo.date_published.split("-").reverse().join("") + ' 00:00:00',
                isfullepisode: (mediaInfo.is_live || mediaInfo.form == 'Integrale') ? 'y' : 'n',
                adloadtype: '2'
            };
            this.adMetadataObject = {
            assetid: 'AD-GENERAL',
            type: 'preroll'
            };
            this.contentLength = mediaInfo.is_live ? 86400 : event.mediaDuration;
            this.lastContentTime = mediaInfo.is_live ? parseInt(Date.now()/1000) : 0;
            this.playerCreated = true;
            this.playerClosed=false;
            this.streamEndFired = false;
        };
        if(event.eventName == events.READY || event.eventName == events.REPLAY || event.eventName == events.ADS.STARTED){
            initNlSdk(event.eventName == events.REPLAY || event.eventName == events.READY);
            this.DEBUG && console.log("Nielsen asset ready");
        }
        if(event.eventName == events.PLAYBACK_STARTED){this.playbackStarted = true;}
        if(!!this.playerClosed || !this.playbackStarted){return};

        switch (event.eventName) {
            case events.ADS.LOADED:
                /*if(this.hbStarted && !this.isInAdv){
                    // se parte il content prima del preroll
                    this.stopHeartbeat(true);
                    this.nSdkInstance.ggPM('stop', this.lastContentTime);
                }
                this.isSeeking=false;
                this.contentBuffering=false;
                this.contentDownloading=false;*/
                break;
            case events.ADS.STARTED:
                this.isSeeking=false;
                this.contentBuffering=false;
                this.contentDownloading=false;
                switch (event.mediaType) {
                    case 'preroll':
                        if(this.hbStarted){
                            this.stopHeartbeat(true); /* se parte il content prima del preroll */
                            this.DEBUG && console.log('rai test: action stop '+ event.mediaType);
                            this.nSdkInstance.ggPM('stop', this.lastContentTime);
                        } else{
                            this.DEBUG && console.log('rai test: action loadmeta '+ event.eventName);
                            this.nSdkInstance.ggPM('loadMetadata', this.contentMetadataObject); /* se c'è preroll è richiesto un loadmetadata del content prima del preroll */
                        }
                        break;
                    case 'midroll':
                        if(this.hbStarted){
                            this.stopHeartbeat(true); /* se non viene invocata la pausa prima del midroll */
                            this.nSdkInstance.ggPM('stop', this.lastContentTime); 
                        }
                        break;
                }
                this.adMetadataObject.assetid = !!event.creativeId ? event.creativeId : Date.now().toString();
                this.adMetadataObject.type = event.mediaType;
                this.isInAdv = true;
                this.DEBUG && console.log('rai test: action loadmeta adv '+ event.mediaType);
                this.nSdkInstance.ggPM('loadMetadata', this.adMetadataObject);
                this.startHeartbeat(0);
                break;
            case events.ADS.ADBUFFERING:
            /* case events.ADS.PAUSED: */
                if(!this.isInAdv){break;}

                this.stopHeartbeat();
                this.DEBUG && console.log('rai test: action stop adv '+ event.eventName);
                this.nSdkInstance.ggPM('stop', this.time);
                break;
            case events.ADS.ADBUFFERINGEND:
            case events.ADS.RESUMED:
                if(this.hbStarted || !this.isInAdv){break;}
                this.DEBUG && console.log('rai test: action loadmeta adv '+ event.mediaType);
                this.nSdkInstance.ggPM('loadMetadata', this.adMetadataObject);
                this.startHeartbeat(this.time);
                break;
            case events.FIRSTPLAY:
                if(!this.hbStarted){
                    this.contentPaused=false;
                    this.contentBuffering=false;
                    this.contentDownloading=false;
                    this.isInAdv = false;
                    this.DEBUG && console.log('rai test: action loadmeta '+ event.eventName);
                    this.nSdkInstance.ggPM('loadMetadata', this.contentMetadataObject);
                    this.startHeartbeat(this.time);
                }
                break;
            case events.PLAYING:
                this.contentPaused=false;
                if(this.isSeeking || this.contentBuffering){return}

                this.contentBuffering=false;
                this.contentDownloading=false;
                if(!!this.hbStarted){
                    if(!!this.isInAdv){
                        this.stopHeartbeat();
                    } else{break;} /*sta già in play*/
                }  
                this.isInAdv = false;
                this.DEBUG && console.log('rai test: action loadmeta '+ event.eventName);
                this.nSdkInstance.ggPM('loadMetadata', this.contentMetadataObject);
                this.startHeartbeat(this.time);
                break;
            case events.PAUSE:
                this.contentPaused=true;
                if((event.mediaDuration <= 2 && !mediaInfo.is_live) || !this.hbStarted){break;}

                this.stopHeartbeat();
                this.DEBUG && console.log('rai test: action stop '+ event.eventName);
                this.nSdkInstance.ggPM('stop', this.time);
                break;
            case events.SEEK_START:
                this.isSeeking=true;
                if(!this.hbStarted){break;}

                if(!mediaInfo.is_live){this.time = parseInt(event.additionalData.startSeekTime);}
                this.stopHeartbeat();
                this.DEBUG && console.log('rai test: action stop '+ event.eventName);
                this.nSdkInstance.ggPM('stop', this.time);
                break;
            case events.SEEK_END:
                this.isSeeking = false;
                if(!!this.hbStarted || this.contentPaused || this.contentBuffering || this.contentDownloading){return;}  //sta già in play o stava in pausa o sta bufferizzando
                
                this.isInAdv = false;
                this.DEBUG && console.log('rai test: action loadmeta '+ event.eventName);
                this.nSdkInstance.ggPM('loadMetadata', this.contentMetadataObject);
                this.startHeartbeat(this.time);
                break;
            case events.DOWNLOAD_DATA_START:
                if(this.isInAdv){return}
                this.contentDownloading = true;
                if(!this.hbStarted){return;}

                this.stopHeartbeat();
                this.DEBUG && console.log('rai test: action stop '+ event.eventName);
                this.nSdkInstance.ggPM('stop', this.time);
                break;
            case events.DOWNLOAD_DATA_END:
                this.contentDownloading = false;
                if(!!this.hbStarted || this.contentPaused){return;}  //sta già in play o stava in pausa

                this.isInAdv = false;
                this.DEBUG && console.log('rai test: action loadmeta '+ event.eventName);
                this.nSdkInstance.ggPM('loadMetadata', this.contentMetadataObject);
                this.startHeartbeat(this.time);
                break;
            case events.BUFFERING_STARTED:
                if(this.isInAdv){return}
                this.contentBuffering = true;
                if(!this.hbStarted){return;}

                this.stopHeartbeat();
                this.DEBUG && console.log('buffering');
                this.DEBUG && console.log('rai test: action stop '+ event.eventName);
                this.nSdkInstance.ggPM('stop', this.time);
                break;
            case events.BUFFERING_END:
                this.contentBuffering=false;
                if(!!this.hbStarted || this.contentPaused){return;}  //sta già in play o stava in pausa

                this.isInAdv = false;
                this.DEBUG && console.log('rai test: action loadmeta '+ event.eventName);
                this.nSdkInstance.ggPM('loadMetadata', this.contentMetadataObject);
                this.startHeartbeat(this.time);
                break;
                //FINE STREAM
            case events.READY_FOR_POSTROLL:
                if(!mediaInfo.is_live){this.sendStreamEnd(this.time);}
                break;
            case events.DISPOSE:
                console.log("test: closePlayer");
                this.closePlayer();
                break;
            case events.ENDED:
                if(mediaInfo.is_live){break;}

                this.playerClosed=true;
                this.sendStreamEnd(this.time);
                break;
            case events.ADS.SKIPPED:
            case events.ADS.COMPLETE:
                this.stopHeartbeat();
                this.DEBUG && console.log('rai test: action stop adv '+ event.eventName);
                this.nSdkInstance.ggPM('stop', this.time);
                break;
            
            case events.NETWORK_ERROR:
                this.stopHeartbeat();
                this.DEBUG && console.log('rai test: action stop '+ event.eventName);
                this.nSdkInstance.ggPM('stop', this.time);
                break;
            case events.ADS.ERROR:
                if(!!this.hbStarted && !!this.isInAdv){
                    this.stopHeartbeat();
                    this.DEBUG && console.log('rai test: action stop '+ event.eventName);
                    nSdkInstance.ggPM('stop', this.time);
                }
                break;
            default:
                this.DEBUG && console.log('Nielsen evento non gestito:' + event.eventName);
                break;
        }
    }
}
